export const useHighlightedFont = () => {
    return {
        getHighlightedFont: (highlight?: boolean) => (highlight ? "s1Medium" : "s1"),
    };
};
